<template>
  <div class="mobile-index" @scroll="centerScroll($event)" v-if="isMobile">
    <div class="index-browser" v-if="isShowTips"></div>
    <div v-else>
      <div class="index-header">
        <a href="/">
          <img :src="staticUrl + 'office/xzdzm/m/game-icon.png'" class="header_icon" />
        </a>
        <div class="header_game">
          <span>仙宗大掌门</span><br />
          开发者名称:上海竹子互联网信息服务有限公司<br />
          版本号:75292.76762 更新时间:2023.6.23<br />
        </div>
        <div class="menu-but" @click="isShowMenu"></div>
        <div class="menu-cover" v-if="isShow">
          <div class="menu-cover-mask" @click="isHiddenMenu"></div>
          <div class="menu-cover-wrap">
            <div class="close-btn" @click="isHiddenMenu"></div>
            <div class="menu-items">
              <div
                class="menu_item"
                :class="{ active: 'center_top' === currentActive }"
                @click="activeClass('center_top')"
              >
                首页
              </div>
              <div class="menu-line"></div>
              <div
                class="menu_item"
                :class="{ active: 'center_zmkb' === currentActive }"
                @click="activeClass('center_zmkb')"
              >
                宗门快报
              </div>
              <div class="menu-line"></div>
              <div
                class="menu_item"
                :class="{ active: 'center_dztj' === currentActive }"
                @click="activeClass('center_dztj')"
              >
                弟子图鉴
              </div>
              <div class="menu-line"></div>
              <div
                class="menu_item"
                :class="{ active: 'center_tese' === currentActive }"
                @click="activeClass('center_tese')"
              >
                仙门特色
              </div>
            </div>
            <div class="menu-share">
              <div class="share-item" @click="createSuperLabel('qq', downloadUrl.qqUrl)">
                <img :src="staticUrl + 'office/xzdzm/m/share-qq.png'" />
              </div>
              <div class="share-item" @click="wxToLink">
                <img :src="staticUrl + 'office/xzdzm/m/share-wechat.png'" />
              </div>
              <div class="share-item" @click="createSuperLabel('sina', downloadUrl.sinaUrl)">
                <img :src="staticUrl + 'office/xzdzm/m/share-weibo.png'" />
              </div>
              <div class="share-item">
                <a href="mailto:xzdzm_cs@zhuziplay.com?subject=contact">
                  <img :src="staticUrl + 'office/xzdzm/m/share-mail.png'" />
                </a>
              </div>
              <div class="share-item" @click="createSuperLabel('taptap', downloadUrl.iosUrl)">
                <img :src="staticUrl + 'office/xzdzm/m/share-tap.png'" />
              </div>
              <div class="share-item" @click="createSuperLabel('bao', downloadUrl.haoyouUrl)">
                <img :src="staticUrl + 'office/xzdzm/m/share-bao.png'" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index-main">
        <div class="center_top" id="center_top">
          <img :src="staticUrl + 'office/xzdzm/m/index-mhome.gif'" class="center_top_video" />
          <div class="center_top_but" @click="tickVideo"></div>
          <div class="center_top_download" v-if="utmSource === ''">
            <div class="download_link">
              <img
                :src="staticUrl + 'office/xzdzm/m/download-game.png'"
                class="download-game"
                @click="tickDownload('ios', downloadUrl.iosUrl)"
                v-if="isIPhone"
              />
              <img
                :src="staticUrl + 'office/xzdzm/m/download-game.png'"
                class="download-game"
                @click="tickDownload('android', downloadUrl.iosUrl)"
                v-else
              />
              <img
                :src="staticUrl + 'office/xzdzm/m/download-tap.png'"
                class="download-img"
                @click="createSuperLabel('taptap', downloadUrl.iosUrl)"
              />
              <img
                :src="staticUrl + 'office/xzdzm/m/download-haoyou.png'"
                class="download-img"
                @click="createSuperLabel('haoyou', downloadUrl.haoyouUrl)"
              />
            </div>
          </div>
          <div class="center_top_download source" v-if="utmSource !== ''">
            <div class="download_link">
              <img
                :src="staticUrl + 'office/xzdzm/m/download-source-game.png'"
                class="download-game"
                @click="tickDownload('ios', downloadUrl.iosUrl)"
                v-if="isIPhone"
              />
              <img
                :src="staticUrl + 'office/xzdzm/m/download-source-game.png'"
                class="download-game"
                @click="tickDownload('android', downloadUrl.iosUrl)"
                v-else
              />
            </div>
            <div class="download_qr">
              <vue-qr ref="qrCode" :text="qrUrl" :size="180" :margin="5" />
            </div>
          </div>
        </div>
        <div class="center_images">
          <div class="center_images_zmkb_title"></div>
          <div class="center_images_zmkb" id="center_zmkb">
            <div class="zmkb_swiper">
              <swiper :options="swiperOptions">
                <swiper-slide v-for="(item, index) in zmkbImg" :key="index">
                  <img :src="item.image" />
                </swiper-slide>
              </swiper>
              <div class="zmkb_swiper_pagination" slot="pagination"></div>
            </div>

            <div class="zmkb_news">
              <div class="zmkb_news_title">最新公告</div>
              <div class="zmkb_news_more" @click="goInformation" v-if="zmkbNewCount > 0">
                查看更多
                <img :src="staticUrl + 'office/xzdzm/pc/more.png'" />
              </div>
              <div class="zmkb_news_items">
                <div
                  class="zmkb_news_item"
                  v-for="(item, index) in zmkbNew"
                  :key="index"
                  @click="goDetail(item.id)"
                >
                  <span class="item-title">[{{ item.keywords }}] {{ item.title }}</span>
                  <span class="item-time">{{ item.published_time.replace("00:00:00", "") }}</span>
                  <div class="item-line"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="center_images_dztj_title"></div>
          <div class="center_images_dztj" id="center_dztj">
            <div class="dztj_swiper">
              <swiper :options="dztjSwiperOptions">
                <swiper-slide>
                  <div class="img_top">
                    <div
                      class="img_small1"
                      :class="1 === xianClick ? 'active' : 'img_small'"
                      @click="xianClickChange(1)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/xian-small1.png'" />
                    </div>
                    <div
                      class="img_small2"
                      :class="2 === xianClick ? 'active' : 'img_small'"
                      @click="xianClickChange(2)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/xian-small2.png'" />
                    </div>
                    <div
                      class="img_small3"
                      :class="3 === xianClick ? 'active' : 'img_small'"
                      @click="xianClickChange(3)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/xian-small3.png'" />
                    </div>
                  </div>
                  <div class="img_main">
                    <img :src="staticUrl + 'office/xzdzm/pc/xian-1.png'" v-if="xianClick === 1" />
                    <img :src="staticUrl + 'office/xzdzm/pc/xian-2.png'" v-if="xianClick === 2" />
                    <img :src="staticUrl + 'office/xzdzm/pc/xian-3.png'" v-if="xianClick === 3" />
                    <div class="img_main_yun"></div>
                    <div class="img_main_title xian_title">
                      <div class="title_tg" v-if="xianClick === 1">紫薇星君</div>
                      <div class="title_desc" v-if="xianClick === 1">帝星浩荡</div>
                      <div class="title_tg" v-if="xianClick === 2">画如梦</div>
                      <div class="title_desc" v-if="xianClick === 2">画中仙子</div>
                      <div class="title_tg" v-if="xianClick === 3">青莲剑仙</div>
                      <div class="title_desc" v-if="xianClick === 3">剑风长歌</div>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="img_top">
                    <div
                      class="img_small1"
                      :class="1 === shenClick ? 'active' : 'img_small'"
                      @click="shenClickChange(1)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/shen-small1.png'" />
                    </div>
                    <div
                      class="img_small2"
                      :class="2 === shenClick ? 'active' : 'img_small'"
                      @click="shenClickChange(2)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/shen-small2.png'" />
                    </div>
                    <div
                      class="img_small3"
                      :class="3 === shenClick ? 'active' : 'img_small'"
                      @click="shenClickChange(3)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/shen-small3.png'" />
                    </div>
                  </div>
                  <div class="img_main">
                    <img :src="staticUrl + 'office/xzdzm/pc/shen-1.png'" v-if="shenClick === 1" />
                    <img :src="staticUrl + 'office/xzdzm/pc/shen-2.png'" v-if="shenClick === 2" />
                    <img :src="staticUrl + 'office/xzdzm/pc/shen-3.png'" v-if="shenClick === 3" />
                    <div class="img_main_yun"></div>
                    <div class="img_main_title shen_title">
                      <div class="title_tg" v-if="shenClick === 1">神帝启</div>
                      <div class="title_desc" v-if="shenClick === 1">众神之首</div>
                      <div class="title_tg" v-if="shenClick === 2">玉璇玑</div>
                      <div class="title_desc" v-if="shenClick === 2">神女慈悲</div>
                      <div class="title_tg" v-if="shenClick === 3">九天玄女</div>
                      <div class="title_desc" v-if="shenClick === 3">万族之首</div>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="img_top">
                    <div
                      class="img_small1"
                      :class="1 === guiClick ? 'active' : 'img_small'"
                      @click="guiClickChange(1)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/gui-small1.png'" />
                    </div>
                    <div
                      class="img_small2"
                      :class="2 === guiClick ? 'active' : 'img_small'"
                      @click="guiClickChange(2)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/gui-small2.png'" />
                    </div>
                    <div
                      class="img_small3"
                      :class="3 === guiClick ? 'active' : 'img_small'"
                      @click="guiClickChange(3)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/gui-small3.png'" />
                    </div>
                  </div>
                  <div class="img_main">
                    <img :src="staticUrl + 'office/xzdzm/pc/gui-1.png'" v-if="guiClick === 1" />
                    <img :src="staticUrl + 'office/xzdzm/pc/gui-2.png'" v-if="guiClick === 2" />
                    <img :src="staticUrl + 'office/xzdzm/pc/gui-3.png'" v-if="guiClick === 3" />
                    <div class="img_main_yun"></div>
                    <div class="img_main_title gui_title">
                      <div class="title_tg" v-if="guiClick === 1">青阎鬼姬</div>
                      <div class="title_desc" v-if="guiClick === 1">青衣门主</div>
                      <div class="title_tg" v-if="guiClick === 2">玄冥鬼祖</div>
                      <div class="title_desc" v-if="guiClick === 2">御鬼道魂</div>
                      <div class="title_tg" v-if="guiClick === 3">紫楼兰</div>
                      <div class="title_desc" v-if="guiClick === 3">幽兰倩影</div>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="img_top">
                    <div
                      class="img_small1"
                      :class="1 === moClick ? 'active' : 'img_small'"
                      @click="moClickChange(1)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/mo-small1.png'" />
                    </div>
                    <div
                      class="img_small2"
                      :class="2 === moClick ? 'active' : 'img_small'"
                      @click="moClickChange(2)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/mo-small2.png'" />
                    </div>
                    <div
                      class="img_small3"
                      :class="3 === moClick ? 'active' : 'img_small'"
                      @click="moClickChange(3)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/mo-small3.png'" />
                    </div>
                  </div>
                  <div class="img_main">
                    <img :src="staticUrl + 'office/xzdzm/pc/mo-1.png'" v-if="moClick === 1" />
                    <img :src="staticUrl + 'office/xzdzm/pc/mo-2.png'" v-if="moClick === 2" />
                    <img :src="staticUrl + 'office/xzdzm/pc/mo-3.png'" v-if="moClick === 3" />
                    <div class="img_main_yun"></div>
                    <div class="img_main_title mo_title">
                      <div class="title_tg" v-if="moClick === 1">赤渊龙帝</div>
                      <div class="title_desc" v-if="moClick === 1">远古魔神</div>
                      <div class="title_tg" v-if="moClick === 2">噬炼魂</div>
                      <div class="title_desc" v-if="moClick === 2">司魂镇魄</div>
                      <div class="title_tg" v-if="moClick === 3">雪夜来</div>
                      <div class="title_desc" v-if="moClick === 3">火爆雪女</div>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="img_top">
                    <div
                      class="img_small1"
                      :class="1 === yaoClick ? 'active' : 'img_small'"
                      @click="yaoClickChange(1)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/yao-small1.png'" />
                    </div>
                    <div
                      class="img_small2"
                      :class="2 === yaoClick ? 'active' : 'img_small'"
                      @click="yaoClickChange(2)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/yao-small2.png'" />
                    </div>
                    <div
                      class="img_small3"
                      :class="3 === yaoClick ? 'active' : 'img_small'"
                      @click="yaoClickChange(3)"
                    >
                      <img :src="staticUrl + 'office/xzdzm/pc/yao-small3.png'" />
                    </div>
                  </div>
                  <div class="img_main">
                    <img :src="staticUrl + 'office/xzdzm/pc/yao-1.png'" v-if="yaoClick === 1" />
                    <img :src="staticUrl + 'office/xzdzm/pc/yao-2.png'" v-if="yaoClick === 2" />
                    <img :src="staticUrl + 'office/xzdzm/pc/yao-3.png'" v-if="yaoClick === 3" />
                    <div class="img_main_yun"></div>
                    <div class="img_main_title yao_title">
                      <div class="title_tg" v-if="yaoClick === 1">紫溟蝶皇</div>
                      <div class="title_desc" v-if="yaoClick === 1">万蝶之皇</div>
                      <div class="title_tg" v-if="yaoClick === 2">苗箐瑶</div>
                      <div class="title_desc" v-if="yaoClick === 2">巫蛊之皇</div>
                      <div class="title_tg" v-if="yaoClick === 3">鹿吟风</div>
                      <div class="title_desc" v-if="yaoClick === 3">医者慈心</div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="dztj_swiper_pagination" slot="pagination"></div>
            </div>
          </div>

          <div class="center_images_tese_title"></div>
          <div class="center_images_tese" id="center_tese">
            <div class="tese_swiper">
              <swiper :options="xmtsMSwiperOptions">
                <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img1.png'" /></swiper-slide>
                <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img2.png'" /></swiper-slide>
                <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img3.png'" /></swiper-slide>
                <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img4.png'" /></swiper-slide>
                <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img5.png'" /></swiper-slide>
              </swiper>
              <div class="tese-swiper-next"></div>
              <div class="tese-swiper-prev"></div>
              <div class="tese-swiper-pagination" slot="pagination"></div>
            </div>
          </div>

          <div class="center_code">
            <div class="center_code_item">
              <img :src="staticUrl + 'office/xzdzm/pc/weibo_code.png'" />微博
            </div>
            <div class="center_code_item">
              <img :src="staticUrl + 'office/xzdzm/pc/weixin_code.png'" />微信
            </div>
            <div class="center_code_item">
              <img :src="staticUrl + 'office/xzdzm/pc/qq_code.png'" />QQ群
            </div>
          </div>
        </div>
      </div>

      <video-play
        :src="homeVideo.videoUrl"
        :controls="isControls"
        @onClose="isShowVideoPlay = false"
        v-if="isShowVideoPlay"
      />
      <wx-link :name="'home'" @onClose="isShowWxLink = false" v-if="isShowWxLink" />
      <new-footer />
    </div>
  </div>

  <div class="pc-index" @scroll="centerScroll($event)" v-else>
    <div class="index-main">
      <div class="center_top" id="center_top">
        <video
          class="center_top_video"
          loop="loop"
          autoplay="autoplay"
          playsinline
          webkit-playsinline
          x5-playsinline
          x5-video-player-type="h5"
          :src="homeVideo.pcIndexVideo"
          muted="muted"
        />
        <div class="center_top_icon"></div>
        <div class="center_top_but" @click="tickVideo"></div>
        <div class="center_top_download">
          <div class="download_code"></div>
          <div class="download_link">
            <img
              :src="staticUrl + 'office/xzdzm/pc/download-ios.png'"
              @click="createSuperLabel('ios', downloadUrl.iosUrl)"
            />
            <img
              :src="staticUrl + 'office/xzdzm/pc/download-leidian.png'"
              @click="createSuperLabel('leidian', downloadUrl.leidianUrl)"
            />
            <img
              :src="staticUrl + 'office/xzdzm/pc/download-and.png'"
              @click="createSuperLabel('android', downloadUrl.iosUrl)"
            />
            <img
              :src="staticUrl + 'office/xzdzm/pc/download-mumu.png'"
              @click="createSuperLabel('mumu', downloadUrl.mumuUrl)"
            />
            <img
              :src="staticUrl + 'office/xzdzm/pc/download-tap.png'"
              @click="createSuperLabel('taptap', downloadUrl.iosUrl)"
            />
            <img
              :src="staticUrl + 'office/xzdzm/pc/download-haoyou.png'"
              @click="createSuperLabel('haoyou', downloadUrl.haoyouUrl)"
            />
          </div>
        </div>
      </div>

      <div class="center_images">
        <div class="center_images_zmkb_title"></div>
        <div class="center_images_zmkb" id="center_zmkb">
          <div class="zmkb_swiper">
            <swiper :options="swiperOptions">
              <swiper-slide v-for="(item, index) in zmkbImg" :key="index">
                <img :src="item.image" />
              </swiper-slide>
            </swiper>
            <div class="zmkb_swiper_pagination" slot="pagination"></div>
          </div>

          <div class="zmkb_news">
            <div class="zmkb_news_title">最新公告</div>
            <div class="zmkb_news_items">
              <div
                class="zmkb_news_item"
                v-for="(item, index) in zmkbNew"
                :key="index"
                @click="goDetail(item.id)"
              >
                <span class="item-title">[{{ item.keywords }}] {{ item.title }}</span>
                <span class="item-time">{{ item.published_time.replace("00:00:00", "") }}</span>
                <div class="item-line"></div>
              </div>
            </div>
            <div class="zmkb_news_more" @click="goInformation" v-if="zmkbNewCount > 0">
              查看更多
              <img :src="staticUrl + 'office/xzdzm/pc/more.png'" />
            </div>
          </div>
        </div>

        <div class="center_images_dztj_title"></div>
        <div class="center_images_dztj" id="center_dztj">
          <div class="dztj_swiper">
            <swiper :options="dztjSwiperOptions">
              <swiper-slide>
                <div class="img_left">
                  <div
                    class="img_left_title"
                    :class="1 === xianClick ? 'xian_title_active' : 'xian_title'"
                  >
                    <div class="img_left_title_tg">紫薇星君</div>
                    <div class="img_left_title_desc">帝星浩荡</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="2 === xianClick ? 'xian_title_active' : 'xian_title'"
                  >
                    <div class="img_left_title_tg">画如梦</div>
                    <div class="img_left_title_desc">画中仙子</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="3 === xianClick ? 'xian_title_active' : 'xian_title'"
                  >
                    <div class="img_left_title_tg">青莲剑仙</div>
                    <div class="img_left_title_desc">剑风长歌</div>
                  </div>
                </div>
                <div class="img_main">
                  <img :src="staticUrl + 'office/xzdzm/pc/xian-1.png'" v-if="xianClick === 1" />
                  <img :src="staticUrl + 'office/xzdzm/pc/xian-2.png'" v-if="xianClick === 2" />
                  <img :src="staticUrl + 'office/xzdzm/pc/xian-3.png'" v-if="xianClick === 3" />
                  <div class="img_main_yun"></div>
                </div>
                <div class="img_right">
                  <div
                    class="img_small1"
                    :class="1 === xianClick ? 'active' : 'img_small'"
                    @click="xianClickChange(1)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/xian-small1.png'" />
                  </div>
                  <div
                    class="img_small2"
                    :class="2 === xianClick ? 'active' : 'img_small'"
                    @click="xianClickChange(2)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/xian-small2.png'" />
                  </div>
                  <div
                    class="img_small3"
                    :class="3 === xianClick ? 'active' : 'img_small'"
                    @click="xianClickChange(3)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/xian-small3.png'" />
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="img_left">
                  <div
                    class="img_left_title"
                    :class="1 === shenClick ? 'shen_title_active' : 'shen_title'"
                  >
                    <div class="img_left_title_tg">神帝启</div>
                    <div class="img_left_title_desc">众神之首</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="2 === shenClick ? 'shen_title_active' : 'shen_title'"
                  >
                    <div class="img_left_title_tg">玉璇玑</div>
                    <div class="img_left_title_desc">神女慈悲</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="3 === shenClick ? 'shen_title_active' : 'shen_title'"
                  >
                    <div class="img_left_title_tg">九天玄女</div>
                    <div class="img_left_title_desc">万族之首</div>
                  </div>
                </div>
                <div class="img_main">
                  <img :src="staticUrl + 'office/xzdzm/pc/shen-1.png'" v-if="shenClick === 1" />
                  <img :src="staticUrl + 'office/xzdzm/pc/shen-2.png'" v-if="shenClick === 2" />
                  <img :src="staticUrl + 'office/xzdzm/pc/shen-3.png'" v-if="shenClick === 3" />
                  <div class="img_main_yun"></div>
                </div>
                <div class="img_right">
                  <div
                    class="img_small1"
                    :class="1 === shenClick ? 'active' : 'img_small'"
                    @click="shenClickChange(1)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/shen-small1.png'" />
                  </div>
                  <div
                    class="img_small2"
                    :class="2 === shenClick ? 'active' : 'img_small'"
                    @click="shenClickChange(2)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/shen-small2.png'" />
                  </div>
                  <div
                    class="img_small3"
                    :class="3 === shenClick ? 'active' : 'img_small'"
                    @click="shenClickChange(3)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/shen-small3.png'" />
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="img_left">
                  <div
                    class="img_left_title"
                    :class="1 === guiClick ? 'gui_title_active' : 'gui_title'"
                  >
                    <div class="img_left_title_tg">青阎鬼姬</div>
                    <div class="img_left_title_desc">青衣门主</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="2 === guiClick ? 'gui_title_active' : 'gui_title'"
                  >
                    <div class="img_left_title_tg">玄冥鬼祖</div>
                    <div class="img_left_title_desc">御鬼道魂</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="3 === guiClick ? 'gui_title_active' : 'gui_title'"
                  >
                    <div class="img_left_title_tg">紫楼兰</div>
                    <div class="img_left_title_desc">幽兰倩影</div>
                  </div>
                </div>
                <div class="img_main">
                  <img :src="staticUrl + 'office/xzdzm/pc/gui-1.png'" v-if="guiClick === 1" />
                  <img :src="staticUrl + 'office/xzdzm/pc/gui-2.png'" v-if="guiClick === 2" />
                  <img :src="staticUrl + 'office/xzdzm/pc/gui-3.png'" v-if="guiClick === 3" />
                  <div class="img_main_yun"></div>
                </div>
                <div class="img_right">
                  <div
                    class="img_small1"
                    :class="1 === guiClick ? 'active' : 'img_small'"
                    @click="guiClickChange(1)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/gui-small1.png'" />
                  </div>
                  <div
                    class="img_small2"
                    :class="2 === guiClick ? 'active' : 'img_small'"
                    @click="guiClickChange(2)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/gui-small2.png'" />
                  </div>
                  <div
                    class="img_small3"
                    :class="3 === guiClick ? 'active' : 'img_small'"
                    @click="guiClickChange(3)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/gui-small3.png'" />
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="img_left">
                  <div
                    class="img_left_title"
                    :class="1 === moClick ? 'mo_title_active' : 'mo_title'"
                  >
                    <div class="img_left_title_tg">赤渊龙帝</div>
                    <div class="img_left_title_desc">远古魔神</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="2 === moClick ? 'mo_title_active' : 'mo_title'"
                  >
                    <div class="img_left_title_tg">噬炼魂</div>
                    <div class="img_left_title_desc">司魂镇魄</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="3 === moClick ? 'mo_title_active' : 'mo_title'"
                  >
                    <div class="img_left_title_tg">雪夜来</div>
                    <div class="img_left_title_desc">火爆雪女</div>
                  </div>
                </div>
                <div class="img_main">
                  <img :src="staticUrl + 'office/xzdzm/pc/mo-1.png'" v-if="moClick === 1" />
                  <img :src="staticUrl + 'office/xzdzm/pc/mo-2.png'" v-if="moClick === 2" />
                  <img :src="staticUrl + 'office/xzdzm/pc/mo-3.png'" v-if="moClick === 3" />
                  <div class="img_main_yun"></div>
                </div>
                <div class="img_right">
                  <div
                    class="img_small1"
                    :class="1 === moClick ? 'active' : 'img_small'"
                    @click="moClickChange(1)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/mo-small1.png'" />
                  </div>
                  <div
                    class="img_small2"
                    :class="2 === moClick ? 'active' : 'img_small'"
                    @click="moClickChange(2)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/mo-small2.png'" />
                  </div>
                  <div
                    class="img_small3"
                    :class="3 === moClick ? 'active' : 'img_small'"
                    @click="moClickChange(3)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/mo-small3.png'" />
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="img_left">
                  <div
                    class="img_left_title"
                    :class="1 === yaoClick ? 'yao_title_active' : 'yao_title'"
                  >
                    <div class="img_left_title_tg">紫溟蝶皇</div>
                    <div class="img_left_title_desc">万蝶之皇</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="2 === yaoClick ? 'yao_title_active' : 'yao_title'"
                  >
                    <div class="img_left_title_tg">苗箐瑶</div>
                    <div class="img_left_title_desc">巫蛊之皇</div>
                  </div>
                  <div
                    class="img_left_title"
                    :class="3 === yaoClick ? 'yao_title_active' : 'yao_title'"
                  >
                    <div class="img_left_title_tg">鹿吟风</div>
                    <div class="img_left_title_desc">医者慈心</div>
                  </div>
                </div>
                <div class="img_main">
                  <img :src="staticUrl + 'office/xzdzm/pc/yao-1.png'" v-if="yaoClick === 1" />
                  <img :src="staticUrl + 'office/xzdzm/pc/yao-2.png'" v-if="yaoClick === 2" />
                  <img :src="staticUrl + 'office/xzdzm/pc/yao-3.png'" v-if="yaoClick === 3" />
                  <div class="img_main_yun"></div>
                </div>
                <div class="img_right">
                  <div
                    class="img_small1"
                    :class="1 === yaoClick ? 'active' : 'img_small'"
                    @click="yaoClickChange(1)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/yao-small1.png'" />
                  </div>
                  <div
                    class="img_small2"
                    :class="2 === yaoClick ? 'active' : 'img_small'"
                    @click="yaoClickChange(2)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/yao-small2.png'" />
                  </div>
                  <div
                    class="img_small3"
                    :class="3 === yaoClick ? 'active' : 'img_small'"
                    @click="yaoClickChange(3)"
                  >
                    <img :src="staticUrl + 'office/xzdzm/pc/yao-small3.png'" />
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="dztj_swiper_pagination" slot="pagination"></div>
          </div>
        </div>

        <div class="center_images_tese_title"></div>
        <div class="center_images_tese" id="center_tese">
          <div class="tese_swiper">
            <swiper :options="xmtsSwiperOptions">
              <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img1.png'" /></swiper-slide>
              <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img2.png'" /></swiper-slide>
              <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img3.png'" /></swiper-slide>
              <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img4.png'" /></swiper-slide>
              <swiper-slide><img :src="staticUrl + 'office/xzdzm/pc/img5.png'" /></swiper-slide>
            </swiper>
            <div class="tese-swiper-next"></div>
            <div class="tese-swiper-prev"></div>
          </div>
        </div>

        <div class="center_code">
          <div class="center_code_item">
            <img :src="staticUrl + 'office/xzdzm/pc/weibo_code.png'" />微博
          </div>
          <div class="center_code_item">
            <img :src="staticUrl + 'office/xzdzm/pc/weixin_code.png'" />微信
          </div>
          <div class="center_code_item">
            <img :src="staticUrl + 'office/xzdzm/pc/qq_code.png'" />QQ群
          </div>
        </div>
      </div>
      <new-footer />
    </div>
    <div class="index-left">
      <div class="menu_items" v-if="'center_top' !== currentActive">
        <div
          class="menu_item"
          :class="{ active: 'center_top' === currentActive }"
          @click="activeClass('center_top')"
        >
          <div class="menu_item_top">首页</div>
        </div>
        <div
          class="menu_item"
          :class="{ active: 'center_zmkb' === currentActive }"
          @click="activeClass('center_zmkb')"
        >
          <div class="menu_item_title">宗门 快报</div>
        </div>
        <div
          class="menu_item"
          :class="{ active: 'center_dztj' === currentActive }"
          @click="activeClass('center_dztj')"
        >
          <div class="menu_item_title">弟子 图鉴</div>
        </div>
        <div
          class="menu_item"
          :class="{ active: 'center_tese' === currentActive }"
          @click="activeClass('center_tese')"
        >
          <div class="menu_item_title">仙门 特色</div>
        </div>
      </div>
    </div>
    <div class="index-right">
      <div class="link_items">
        <div class="link_null"></div>
        <div class="link_item qq" @click="createSuperLabel('qq', downloadUrl.qqUrl)">
          <img :src="staticUrl + 'office/xzdzm/pc/share-qq.png'" />
        </div>
        <div class="link_item wechat" @click="wxToLink">
          <img :src="staticUrl + 'office/xzdzm/pc/share-wechat.png'" />
        </div>
        <div class="link_item weibo" @click="createSuperLabel('sina', downloadUrl.sinaUrl)">
          <img :src="staticUrl + 'office/xzdzm/pc/share-weibo.png'" />
        </div>
        <div class="link_item mail">
          <a href="mailto:xzdzm_cs@zhuziplay.com?subject=contact">
            <img :src="staticUrl + 'office/xzdzm/pc/share-mail.png'" />
          </a>
        </div>
        <div class="link_item tap" @click="createSuperLabel('taptap', downloadUrl.iosUrl)">
          <img :src="staticUrl + 'office/xzdzm/pc/share-tap.png'" />
        </div>
        <div class="link_item bao" @click="createSuperLabel('bao', downloadUrl.haoyouUrl)">
          <img :src="staticUrl + 'office/xzdzm/pc/share-bao.png'" />
        </div>
      </div>
    </div>
    <video-play
      :src="homeVideo.videoUrl"
      :controls="isControls"
      @onClose="isShowVideoPlay = false"
      v-if="isShowVideoPlay"
    />
    <wx-link :name="'home'" @onClose="isShowWxLink = false" v-if="isShowWxLink" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { NewFooter, VideoPlay, WxLink } from '@/components';
import VueQr from 'vue-qr';
import thinkingdata from 'thinkingdata-browser';

export default {
  name: 'home',
  components: {
    VideoPlay,
    WxLink,
    NewFooter,
    VueQr,
  },
  computed: {
    ...mapGetters([
      'thinkingConfig',
      'systemBrowser',
      'homeVideo',
      'downloadUrl',
      'staticUrl',
      'isIPhone',
      'gameImgPid',
      'gameImgPcPid',
      'basicData',
      'isAppStore',
      'isMobile',
      'utmSource',
      'adPosition',
    ]),
  },
  data () {
    return {
      qrUrl: location.href,
      isShowTips: false,
      isShow: false,
      currentActive: 'center_top',
      teseImg: [],
      zmkbImg: [],
      zmkbNew: [],
      zmkbNewCount: 0,
      isShowWxLink: false,
      isShowVideoPlay: false,
      isControls: true,
      swiperOptions: {
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        loop: true,
        pagination: {
          el: '.zmkb_swiper_pagination',
          clickable: true,
        },
      },
      shenClick: 1,
      xianClick: 3,
      moClick: 1,
      guiClick: 1,
      yaoClick: 3,
      dztjSwiperOptions: {
        centeredSlides: true,
        spaceBetween: 30,
        autoplay: {
          delay: 50000,
          disableOnInteraction: true,
        },
        loop: true,
        pagination: {
          el: '.dztj_swiper_pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<div class="' +
              className +
              '"><span class="' +
              'text' +
              (index + 1) +
              '"></span></div>'
            );
          },
        },
      },
      xmtsMSwiperOptions: {
        centeredSlides: true,
        spaceBetween: 30,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        loop: true,
        pagination: {
          el: '.tese-swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.tese-swiper-next',
          prevEl: '.tese-swiper-prev',
        },
      },
      xmtsSwiperOptions: {
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        loop: true,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          stretch: 908,
          depth: 300,
          slideShadows: true,
        },
        navigation: {
          nextEl: '.tese-swiper-next',
          prevEl: '.tese-swiper-prev',
        },
      },
    };
  },
  mounted () {
    document.addEventListener('scroll', this.centerScroll, true);
  },
  created () {
    this.getGamesImg();
    this.getZmkbData();
    document.addEventListener(
      'WeixinJSBridgeReady',
      function () {
        document.querySelector('.center_top_video').play();
        document.querySelector('.tese_swiper_video').play();
      },
      false
    );
    if (typeof this.$route.query['download'] !== 'undefined') {
      if (this.systemBrowser === 'app') {
        this.isShowTips = true;
        if (this.utmSource !== '') {
          if (this.adPosition !== '') {
            this.$router.push({
              name: 'home',
              query: {
                download: this.$route.query['download'],
                utm_source: this.utmSource,
                ad_position: this.adPosition,
              },
            });
          } else {
            this.$router.push({
              name: 'home',
              query: { download: this.$route.query['download'], utm_source: this.utmSource },
            });
          }
        } else {
          this.$router.push({ name: 'home', query: { download: this.$route.query['download'] } });
        }
      } else {
        this.isShowTips = false;
        if (this.utmSource !== '') {
          this.sendThinkingdata();
        }
        if (typeof this.isIPhone !== 'undefined' && this.isIPhone) {
          window.location.href = this.downloadUrl.iosUrl;
        } else {
          window.location.href = this.downloadUrl.iosUrl;
          alert('游戏下载中，请到下载任务管理查看');
        }
      }
    }
  },
  methods: {
    ...mapActions(['getBannerList', 'getNewsList']),
    isShowMenu () {
      this.isShow = true;
    },
    isHiddenMenu () {
      this.isShow = false;
    },
    tickVideo () {
      this.isShowVideoPlay = true;
    },
    wxToLink () {
      this.isShowWxLink = true;
    },
    tickDownload (id, url) {
      if (this.systemBrowser === 'app') {
        this.isShowTips = true;
        this.$router.push({ name: 'home', query: { download: id } });
      } else {
        this.isShowTips = false;
        if (!this.isIPhone) {
          this.showSuccess('游戏下载中，请到下载任务管理查看');
        }
        if (this.utmSource !== '') {
          this.sendThinkingdata();
        }
        window.location.href = url;
      }
    },
    createSuperLabel (id, url) {
      let a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('target', '_blank');
      a.setAttribute('id', id);
      if (!document.getElementById(id)) {
        document.body.appendChild(a);
      }
      a.click();
    },
    getZmkbData () {
      this.getNewsList({ pageNo: 1, pageSize: 5 })
        .then((res) => {
          let zmkbImg = [];
          res.list.forEach((element) => {
            if (element.thumb_image) {
              zmkbImg.push({ image: element.thumb_image });
            }
          });
          this.zmkbNew = res.list;
          this.zmkbNewCount = res.totalCount;
          this.zmkbImg = zmkbImg;
        })
        .catch(() => {
          this.showError('您的请求参数错误！');
        });
    },
    getGamesImg () {
      let position_id = this.gameImgPcPid;
      let xmtsVideo = this.xmtsPcVideo;
      if (this.isMobile) {
        position_id = this.gameImgPid;
        xmtsVideo = this.xmtsVideo;
      }
      this.getBannerList({ position_id: position_id, status: 1 })
        .then((res) => {
          res.list.push({ image: xmtsVideo, title: '视频', id: 'video' });
          this.teseImg = res.list;
        })
        .catch(() => {
          this.showError('您的请求参数错误！');
        });
    },
    centerScroll () {
      var scrollVals = [
        { top: 0, id: 'center_top' },
        { top: 50, id: 'center_zmkb' },
        { top: 100, id: 'center_dztj' },
        { top: 150, id: 'center_tese' },
      ];
      scrollVals[0].top = document.querySelector('#center_top').getBoundingClientRect().top;
      scrollVals[1].top = document.querySelector('#center_zmkb').getBoundingClientRect().top;
      scrollVals[2].top = document.querySelector('#center_dztj').getBoundingClientRect().top;
      scrollVals[3].top = document.querySelector('#center_tese').getBoundingClientRect().top;
      let minTopArr = this.topSort(scrollVals, 'top');
      if (this.currentActive !== minTopArr[0].id) {
        this.currentActive = minTopArr[0].id;
      }
    },
    topSort (objArr, key) {
      let result = objArr.slice(0);
      return result.sort((a, b) => Math.abs(a[key]) - Math.abs(b[key]));
    },
    activeClass (index) {
      this.currentActive = index;
      document.querySelector('#' + index).scrollIntoView({ behavior: 'smooth' });
    },
    goInformation () {
      this.$router.push({ name: 'information', query: {} });
    },
    goDetail (id) {
      this.$router.push({ name: 'informationDetail', query: { id: id } });
      console.log(id);
    },
    shenClickChange (index) {
      this.shenClick = index;
    },
    xianClickChange (index) {
      this.xianClick = index;
    },
    moClickChange (index) {
      this.moClick = index;
    },
    guiClickChange (index) {
      this.guiClick = index;
    },
    yaoClickChange (index) {
      this.yaoClick = index;
    },
    sendThinkingdata () {
      thinkingdata.init(this.thinkingConfig);
      if (this.isIPhone) {
        // 发送事件
        thinkingdata.track('page_download', {
          download_type: 'apple',
          source_channel: this.utmSource,
          ad_position: this.adPosition,
        });
      } else {
        // 发送事件
        thinkingdata.track('page_download', {
          download_type: 'apk',
          source_channel: this.utmSource,
          ad_position: this.adPosition,
        });
      }
    },
  },
};
</script>
<style lang="scss">
// @import '@/assets/mobile/home.scss';
// @import "@/assets/styles/home.scss";
</style>
